import { COMMON_TEXT } from '@/helpers/common-text';
import {
  QUERY_STRING_STORE,
} from '@/helpers/constants';
import {
  generateRandomString,
  getConfigurationUrlWithParam,
} from '@/helpers/utility';
import { cloneDeep } from 'lodash';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import EmployeeCSV from './EmployeeCSV';
import EmployeeInfoDialog from './EmployeeInfoDialog';
import { fetchEmployees } from './query-request';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import Toaster from 'src/components/CustomComponent/Toaster';
import EditIcon from 'src/components/CustomComponent/EditIcon/EditIcon';
import DeleteIcon from 'src/components/CustomComponent/DeleteIcon/DeleteIcon';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';
import './EmployeeSetting.less';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      dataList: [],
      dialogVisibleCount: 0,
      editingEmployee: {},
      searchFilters: {
        employeeName: '',
        employeeDepartment: '',
        employeeTeam: '',
      },
    };
    this.toastRef = React.createRef();
    this.filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      employeeName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      employeeDepartment: { value: null, matchMode: FilterMatchMode.CONTAINS },
      employeeTeam: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },
    };
    this.emplRowStatus = {
      UNCHANGED: 0,
      NEW: 1,
      MODIFIED: 2,
      DELETED: 3,
    };
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  renderBackToConfigButton = () => {
    const { isLoading } = this.state;
    return (
      <Button
        label={`戻る`}
        loading={isLoading}
        className="back-button has-shadow"
        severity="secondary"
        size="small"
        onClick={() => {
          this.getData();
        }}
      />
    );
  };

  getData = async () => {
    const { tenant } = this.state;
    this.setState({ isLoading: true });
    const employees = await fetchEmployees({ tenantId: tenant });
    const newEmployeeList = employees.map(employee => {
      return {
        employeeId: employee.employee_id,
        employeeName: employee.employee_name,
        employeeDepartment: employee.department,
        employeeTeam: employee.team,
        status: this.emplRowStatus.UNCHANGED,
        rowIndexId: generateRandomString(16),
      };
    });
    this.setState({
      dataList: cloneDeep(newEmployeeList),
      isLoading: false,
    });
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    const { isSuccess, errorMessage } = await this.updateEmployeeInfo({
      updatePayLoad,
    });

    if (isSuccess) {
      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        this.getData();
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        // Show specific error message if available, otherwise generic message
        const message = errorMessage || COMMON_TEXT.SAVE_FAILED;
        Toaster.error(message);
      });
    }
  };

  updateEmployeeInfo = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsEmployees({
        apiPostWorkflowRequest: {
          ...updatePayLoad,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('UPDATE SETTING ERROR');
      }
      return { isSuccess: true };
    } catch (error) {
      // Extract error message from API response
      let errorMessage = null;

      // For ResponseError from OpenAPI client, extract from response body
      if (error.name === 'ResponseError' && error.response) {
        try {
          // Clone the response to avoid consuming it
          const responseClone = error.response.clone();
          const responseText = await responseClone.text();

          // Try to parse as JSON and extract the message field
          try {
            const responseJson = JSON.parse(responseText);
            if (responseJson.message) {
              errorMessage = responseJson.message;
            } else {
              errorMessage = responseText;
            }
          } catch (parseError) {
            // If not JSON, use the text as-is
            errorMessage = responseText;
          }
        } catch (e) {
          // Failed to extract error text
        }
      }

      // Fallback to error message
      if (!errorMessage && error.message) {
        errorMessage = error.message;
      }

      return { isSuccess: false, errorMessage };
    }
  };

  renderSearchSection() {
    const { searchFilters } = this.state;

    const handleSearchChange = (field, value) => {
      this.setState({
        searchFilters: {
          ...searchFilters,
          [field]: value,
        },
      });
    };

    const SearchIcon = () => (
      <svg className="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.3333 15.5L9.08333 10.25C8.66667 10.5833 8.1875 10.8472 7.64583 11.0417C7.10417 11.2361 6.52778 11.3333 5.91667 11.3333C4.40278 11.3333 3.12153 10.809 2.07292 9.76042C1.02431 8.71181 0.5 7.43056 0.5 5.91667C0.5 4.40278 1.02431 3.12153 2.07292 2.07292C3.12153 1.02431 4.40278 0.5 5.91667 0.5C7.43056 0.5 8.71181 1.02431 9.76042 2.07292C10.809 3.12153 11.3333 4.40278 11.3333 5.91667C11.3333 6.52778 11.2361 7.10417 11.0417 7.64583C10.8472 8.1875 10.5833 8.66667 10.25 9.08333L15.5 14.3333L14.3333 15.5ZM5.91667 9.66667C6.95833 9.66667 7.84375 9.30208 8.57292 8.57292C9.30208 7.84375 9.66667 6.95833 9.66667 5.91667C9.66667 4.875 9.30208 3.98958 8.57292 3.26042C7.84375 2.53125 6.95833 2.16667 5.91667 2.16667C4.875 2.16667 3.98958 2.53125 3.26042 3.26042C2.53125 3.98958 2.16667 4.875 2.16667 5.91667C2.16667 6.95833 2.53125 7.84375 3.26042 8.57292C3.98958 9.30208 4.875 9.66667 5.91667 9.66667Z" fill="white" />
      </svg>
    );

    return (
      <div className="search-inputs-container">
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="名前"
            value={searchFilters.employeeName}
            onChange={(e) => handleSearchChange('employeeName', e.target.value)}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="部署"
            value={searchFilters.employeeDepartment}
            onChange={(e) => handleSearchChange('employeeDepartment', e.target.value)}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="チーム"
            value={searchFilters.employeeTeam}
            onChange={(e) => handleSearchChange('employeeTeam', e.target.value)}
            className="search-input"
          />
        </div>
      </div>
    );
  }

  renderHeaderActions() {
    const { isLoading, isUpdating } = this.state;

    const getUpdatePayload = ({ employeeList }) => {
      const payload = {
        values: [],
      };
      const newEmployees = employeeList.filter(
        employee => employee.status === this.emplRowStatus.NEW
      );
      const newEmployeesSet = new Set();
      newEmployees.forEach(element => {
        newEmployeesSet.add(JSON.stringify(element));
      });
      let newEmployeesArray = [];
      newEmployeesSet.forEach(element => {
        newEmployeesArray.push(JSON.parse(element));
      });

      if (newEmployeesArray && newEmployeesArray.length > 0) {
        newEmployeesArray.forEach(employee => {
          const newEmployee = this.convertEmployeeObjectToPayLoad({ employee });
          payload.values.push(newEmployee);
        });
      }
      const modifiedEmployees = employeeList.filter(
        employee => employee.status === this.emplRowStatus.MODIFIED
      );
      if (modifiedEmployees && modifiedEmployees.length > 0) {
        modifiedEmployees.forEach(employee => {
          const modifiedEmployee = this.convertEmployeeObjectToPayLoad({
            employee,
          });
          payload.values.push(modifiedEmployee);
        });
      }
      const deletedEmployees = employeeList.filter(
        employee => employee.status === this.emplRowStatus.DELETED
      );
      if (deletedEmployees && deletedEmployees.length > 0) {
        deletedEmployees.forEach(employee => {
          const deletedEmployee = {
            employee_id: employee.employeeId,
            employee_number: null,
          };
          payload.values.push(deletedEmployee);
        });
      }
      return { payload };
    };

    const submitButtonOnClicked = () => {
      const { dataList } = this.state;
      const employeeList = dataList.filter(
        employee => employee.status !== this.emplRowStatus.UNCHANGED
      );

      if (employeeList.length > 0) {
        // Check for duplicate MAC addresses within the batch
        const macAddressMap = new Map();
        const duplicateErrors = [];

        employeeList.forEach(employee => {
          // Check PC MAC address
          if (employee.employeePcMac && employee.employeePcMac.trim() !== '') {
            const mac = employee.employeePcMac.trim().toUpperCase();
            if (macAddressMap.has(mac)) {
              const existingEmployee = macAddressMap.get(mac);
              duplicateErrors.push(
                `PC MACアドレス ${mac} が重複しています: ${existingEmployee.employeeName} と ${employee.employeeName}`
              );
            } else {
              macAddressMap.set(mac, employee);
            }
          }

          // Check Mobile MAC address
          if (employee.employeeMobileMac && employee.employeeMobileMac.trim() !== '') {
            const mac = employee.employeeMobileMac.trim().toUpperCase();
            if (macAddressMap.has(mac)) {
              const existingEmployee = macAddressMap.get(mac);
              duplicateErrors.push(
                `Mobile MACアドレス ${mac} が重複しています: ${existingEmployee.employeeName} と ${employee.employeeName}`
              );
            } else {
              macAddressMap.set(mac, employee);
            }
          }
        });

        if (duplicateErrors.length > 0) {
          this.toastRef.current.show({
            severity: 'error',
            summary: 'エラー',
            detail: duplicateErrors.join('; '),
            life: 5000,
            closable: true,
          });
          return;
        }

        const { payload } = getUpdatePayload({ employeeList });
        this.updateData({ updatePayLoad: payload });
      } else {
        this.toastRef.current.show({
          severity: 'info',
          summary: '情報',
          detail: COMMON_TEXT.NO_CHANGE_TO_BE_SAVED,
          life: 3000,
          closable: true,
        });
        return;
      }
    };

    return (
      <div className="header-actions">
        <EmployeeCSV
          tenantId={this.state.tenant}
          updateCsvData={this.updateCsvData}
        />
        <SaveButton
          loading={isUpdating}
          disabled={isLoading}
          onClick={() => submitButtonOnClicked()}
        />
      </div>
    );
  }

  convertToEmployeeObject = ({ employee }) => {
    return {
      employeeId: employee.employee_id,
      employeeName: employee.employee_name,
      employeeNumber: employee.employee_number,
      employeeNameReading: employee.employee_name_reading,
      employeePhoneNumber: employee.phone_number,
      employeePhoneNumber2: employee.phone_number2,
      employeeEmail: employee.email,
      employeeBranchId: employee.branch_id,
      employeeFloorId: employee.floor_id,
      employeeImage: employee.employee_image,
      employeeChatTools: employee.chat_tools,
      employeeDepartment: employee.department,
      employeeTeam: employee.team,
      employeeVerkadaId: employee.employee_identifer,
      employeePcMac: employee.employee_device_pc_mac,
      employeePcName: employee.employee_device_pc_name,
      employeeMobileMac: employee.employee_device_mobile_mac,
      employeeMobileName: employee.employee_device_mobile_name,
      initEmployee: employee.initEmployee,
      status: employee.status,
      rowIndexId: generateRandomString(16),
    };
  };

  convertEmployeeObjectToPayLoad = ({ employee }) => {
    const {
      employeePcMac,
      employeeMobileMac,
      employeePcName,
      employeeMobileName,
      employeeId,
    } = employee;
    const obj = {
      employee_id: !employeeId || employeeId === 0 ? null : employeeId,
      employee_name: employee.employeeName ?? '',
      employee_name_reading: employee.employeeNameReading ?? '',
      employee_number: employee.employeeNumber ?? '',
      phone_number: employee.employeePhoneNumber ?? '',
      phone_number2: employee.employeePhoneNumber2 ?? '',
      email: employee.employeeEmail ?? '',
      branch_id: employee.employeeBranchId ?? '',
      floor_id: employee.employeeFloorId ?? '',
      employee_image: employee.employeeImage ?? '',
      chat_tools: employee.employeeChatTools ?? '',
      department: employee.employeeDepartment ?? '',
      team: employee.employeeTeam ?? '',
      verkada_employee_id: employee.employeeVerkadaId ?? '',
      devices: [],
    };

    const { initEmployee } = employee;
    if (!initEmployee) {
      console.error('initEmployee is not found');
    }
    const { employeePcMac: initPcMac, employeeMobileMac: initMobileMac } =
      initEmployee || {};

    if (employeePcMac || employeePcName) {
      obj.devices.push({
        type: 'pc',
        mac: employeePcMac,
        name: employeePcName,
      });
      if (initPcMac && employeePcMac !== initPcMac) {
        obj.devices.push({
          type: null,
          mac: initPcMac,
        });
      }
    }
    if (employeeMobileMac || employeeMobileName) {
      obj.devices.push({
        type: 'phone',
        mac: employeeMobileMac,
        name: employeeMobileName,
      });
      if (initMobileMac && employeeMobileMac !== initMobileMac) {
        obj.devices.push({
          type: null,
          mac: initMobileMac,
        });
      }
    }
    return obj;
  };

  updateCsvData = data => {
    const convertedDataList = data.map(employee => {
      return this.convertToEmployeeObject({ employee });
    });
    this.setState({
      dataList: convertedDataList,
    });
  };

  customSortIcon = (options) => {
    let iconSrc;
    if (options.sorted) {
      if (options.sortOrder < 0) {
        iconSrc = "/assets/img/sort-down-icon.svg";
      } else {
        iconSrc = "/assets/img/sort-up-icon.svg";
      }
    } else {
      iconSrc = "/assets/img/sort-icon.svg";
    }
    return (
      <img
        src={iconSrc}
        alt="sort"
        className="custom-sort-icon"
        {...options.iconProps}
      />
    );
  };

  renderEmployeeTable() {
    const { dataList, searchFilters } = this.state;

    // Filter data based on search filters
    const filteredData = dataList.filter(employee => {
      const nameMatch = !searchFilters.employeeName ||
        employee.employeeName.toLowerCase().includes(searchFilters.employeeName.toLowerCase());
      const departmentMatch = !searchFilters.employeeDepartment ||
        employee.employeeDepartment.toLowerCase().includes(searchFilters.employeeDepartment.toLowerCase());
      const teamMatch = !searchFilters.employeeTeam ||
        employee.employeeTeam.toLowerCase().includes(searchFilters.employeeTeam.toLowerCase());

      return nameMatch && departmentMatch && teamMatch;
    });

    const confirmDeleteEmployee = ({ index, employeeList }) => {
      let employee = employeeList[index];
      const { employeeId } = employee;
      if (employeeId) {
        employee.status = this.emplRowStatus.DELETED;
        employeeList[index] = employee;
      } else {
        employeeList.splice(index, 1);
      }

      this.setState({ dataList: employeeList });
    };

    const deleteEmployeeButtonOnClicked = async (
      e,
      { employee, index, employeeList }
    ) => {
      const { employeeName, employeeDepartment, employeeTeam } = employee;
      confirmDialog({
        message: () => (
          <div
            className="user-info-container delete-message-container"
            style={{ padding: '0px 40px 0px 20px', maxHeight: 'calc(70vh - 140px)', overflowY: 'auto', background: 'none' }}
          >
            <div className="mt-4 flex align-items-center" style={{ marginBottom: 8 }}>
              <div style={{ width: '120px', color: '#A2A8BB', fontWeight: 700 }}>{COMMON_TEXT.NAME}</div>
              <div>
                <b style={{ color: '#fff' }}>{employeeName}</b>
              </div>
            </div>
            <div className="mt-2 flex align-items-center" style={{ marginBottom: 8 }}>
              <div style={{ width: '120px', color: '#A2A8BB', fontWeight: 700 }}>{COMMON_TEXT.DEPARTMENT}</div>
              <div>
                <b style={{ color: '#fff' }}>{employeeDepartment}</b>
              </div>
            </div>
            <div className="mt-2 flex align-items-center">
              <div style={{ width: '120px', color: '#A2A8BB', fontWeight: 700 }}>{COMMON_TEXT.TEAM}</div>
              <div>
                <b style={{ color: '#fff' }}>{employeeTeam}</b>
              </div>
            </div>
          </div>
        ),
        header: '削除してよろしいですか？',
        icon: null,
        className: 'user-setting-info-dialog',
        style: { width: '500px' },
        accept: () => confirmDeleteEmployee({ index, employeeList }),
        reject: () => { },
        acceptClassName: 'p-button-danger',
        rejectClassName: 'p-button-secondary p-button-text',
        appendTo: 'self',
      });
    };

    const editEmployeeButtonOnClicked = (e, { employee, employeeIndex }) => {
      this.setState({
        editingEmployee: employee,
        dialogVisibleCount: new Date().getTime(),
      });
    };

    const getRowIndex = rowData => {
      return dataList.findIndex(data => {
        return data.rowIndexId === rowData.rowIndexId;
      });
    };

    const actionBodyTemplate = rowData => {
      const rowIndex = getRowIndex(rowData);
      const { status } = rowData;
      return (
        <div className="action-body-container" style={{ display: 'flex', gap: '10px' }}>
          <Button
            type="button"
            text
            disabled={status === this.emplRowStatus.DELETED}
            severity="info"
            onClick={e =>
              editEmployeeButtonOnClicked(e, {
                employee: rowData,
                employeeIndex: rowIndex,
              })
            }
          >
            <EditIcon />
          </Button>
          <Button
            type="button"
            text
            disabled={status === this.emplRowStatus.DELETED}
            severity="danger"
            onClick={e =>
              deleteEmployeeButtonOnClicked(e, {
                employee: rowData,
                index: rowIndex,
                employeeList: dataList,
              })
            }
          >
            <DeleteIcon />
          </Button>
        </div>
      );
    };

    const statusBodyTemplate = (rowData, rowProps) => {
      const { status } = rowData;
      let statusText = '';
      const getSeverity = status => {
        switch (status) {
          case this.emplRowStatus.NEW:
            return 'success';
          case this.emplRowStatus.MODIFIED:
            return 'info';
          case this.emplRowStatus.UNCHANGED:
            return '';
          case this.emplRowStatus.DELETED:
            return 'danger';
          default:
            return '';
        }
      };
      if (status === this.emplRowStatus.NEW) {
        statusText = '新規';
      } else if (status === this.emplRowStatus.MODIFIED) {
        statusText = '修正';
      } else if (status === this.emplRowStatus.UNCHANGED) {
        statusText = '';
      } else if (status === this.emplRowStatus.DELETED) {
        statusText = '削除';
      }
      return (
        <div className="status-body-container">
          {statusText && (
            <Tag value={statusText} severity={getSeverity(status)} />
          )}
        </div>
      );
    };

    return (
      <>
        <div className="table-container">
          <DataTable
            className="employee-data-table"
            value={filteredData}
            dataKey="rowIndexId"
            tableStyle={{ minWidth: '60rem' }}
            scrollable
            scrollHeight="100%"
            size="medium"
            stripedRows
            rowHover
            showGridlines
            selectionMode="single"
            sortIcon={this.customSortIcon}
            headerStyle={{
              color: '#A2A8BB',
              fontWeight: 'bold',
              fontSize: 12,
              fontFamily: 'DM Sans, Noto Sans JP, sans-serif'
            }}
            bodyStyle={{
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 12,
              fontFamily: 'DM Sans, Noto Sans JP, sans-serif'
            }}
            emptyMessage={() => {
              return (
                <div className="no-data-container">
                  {COMMON_TEXT.NO_DATA}
                </div>
              );
            }}
          >
            <Column
              field="employeeName"
              header={COMMON_TEXT.NAME}
              sortable
            />
            <Column
              field="employeeDepartment"
              header={COMMON_TEXT.DEPARTMENT}
              sortable
            />
            <Column
              field="employeeTeam"
              header={COMMON_TEXT.TEAM}
              sortable
            />
            <Column
              field="status"
              header={COMMON_TEXT.STATUS}
              body={statusBodyTemplate}
            />
            <Column
              headerStyle={{ width: '5rem', textAlign: 'center' }}
              bodyStyle={{ textAlign: 'center', overflow: 'visible' }}
              body={actionBodyTemplate}
            />
          </DataTable>
        </div>
      </>
    );
  }

  employeeInfoOnModified = ({ employee }) => {
    const { dataList } = this.state;
    const { rowIndexId } = employee;
    const findIndex = dataList.findIndex(
      data => data.rowIndexId === rowIndexId
    );
    if (findIndex >= 0) {
      dataList[findIndex] = {
        ...employee,
      };
    } else {
      dataList.push(employee);
    }
    this.setState({ dataList });
  };

  addNewEmployeeButtonOnClicked = () => {
    this.setState({
      editingEmployee: {
        employeeId: '',
        employeeName: '',
        employeeNumber: '',
        employeePhoneNumber: '',
        employeeEmail: '',
        employeeBranchId: '',
        employeeFloorId: '',
        employeeChatTools: '',
        employeeDepartment: '',
        employeeImage: '',
        employeeVerkadaId: '',
        employeeTeam: '',
        employeePcMac: '',
        employeeMobileMac: '',
        employeePcName: '',
        employeeMobileName: '',
        status: this.emplRowStatus.NEW,
        rowIndexId: generateRandomString(16),
      },
      dialogVisibleCount: new Date().getTime(),
    });
  };

  render() {
    const { dialogVisibleCount, editingEmployee, tenant, isLoading, dataList } = this.state;

    // Calculate employee count (excluding deleted employees)
    const employeeCount = dataList?.filter(employee => employee.status !== this.emplRowStatus.DELETED).length || 0;

    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />
        <EmployeeInfoDialog
          tenantId={tenant}
          dialogVisibleCount={dialogVisibleCount}
          selectedEmployee={editingEmployee}
          updateEmployeeInfo={this.employeeInfoOnModified}
          dataList={dataList}
        ></EmployeeInfoDialog>
        <div className="config-container custom-config-container employee-setting-container custom-setting-config-container">
          <div className="config-title-container">
            <div className="text-left">
              <div className="title-text">
                {COMMON_TEXT.COMPANY_EMPLOYEE_SETTING}
                <span className="title-count">{employeeCount}</span>
              </div>
            </div>
            <div className="grid grid-nogutter align-items-center justify-content-end">
              {this.renderHeaderActions()}
            </div>
          </div>
          <div className="config-content">
            <>{this.renderSearchSection()}</>
            <div className="setting-content">
              {isLoading ? (
                <div className="ml-auto mr-auto">
                  <LoadingSpinner />
                </div>
              ) : (
                <>
                  {this.renderEmployeeTable()}
                  <div className="button-container">
                    <Button
                      type="button"
                      label="追加"
                      severity="success"
                      className="has-shadow"
                      onClick={this.addNewEmployeeButtonOnClicked}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

EmployeeSetting.propTypes = {};

export default EmployeeSetting;
